<mat-card class="crud-search-card">
  <mat-card-title i18n="@@type.Firearm">Firearm Assets</mat-card-title>
  <mat-card-content>
    <form [formGroup]="searchForm">
      <div>
        <app-asset-search-filters composedAssetClass="Firearm"
          [disabledFilters]="['assetType']"></app-asset-search-filters>
      </div>

      <div class="search-section">
        <mat-form-field matTooltip="Select a Calibre from the list"
          [matTooltipDisabled]="disabledTooltip(this.calibre)">
          <mat-label i18n="@@type.Firearm.calibre">Calibre</mat-label>
          <mat-select formControlName="calibre" id="calibreFilterInput" (ngModelChange)="calibreChanging($event)"
            [(ngModel)]="calibreFilter" (ngModelChange)="calibreChanged($event)" #calibreFilterInput
            placeholder="Calibre">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let calibre of calibreSelectionList" [value]="calibre.code">
              {{calibre.meaning}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field matTooltip="Select a Pool Firearm from the list" [matTooltipDisabled]="disabledTooltip(this.poolFirearm)">
          <mat-label i18n="@@type.Firearm.poolFirearm">Pool Firearm</mat-label>
          <mat-select formControlName="poolFirearm" id="poolFirearmFilterInput"              
              (ngModelChange)="poolFirearmChanging($event)" [(ngModel)]="poolFirearmFilter"              
              (ngModelChange)="poolFirearmChanged($event)" #poolFirearmFilterInput>
            <mat-option>Any</mat-option>
            <mat-option [value]="true" i18n="@@type.boolean.true">Yes</mat-option>
            <mat-option [value]="false" i18n="@@type.boolean.false">No</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field matTooltip="Select a Firearm Type from the list"
          [matTooltipDisabled]="disabledTooltip(this.firearmType)">
          <mat-label i18n="@@type.Firearm.firearmType">Firearm Type</mat-label>
          <mat-select formControlName="firearmType" id="firearmTypeFilterInput"
            (ngModelChange)="firearmTypeChanging($event)" [(ngModel)]="firearmTypeFilter"
            (ngModelChange)="firearmTypeChanged($event)" #firearmTypeFilterInput placeholder="Firearm Type">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let firearmType of firearmTypeSelectionList" [value]="firearmType.code">
              {{firearmType.meaning}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        
        <mat-form-field matTooltip="Select a Personal Firearm from the list" [matTooltipDisabled]="disabledTooltip(this.personalFirearm)">
          <mat-label i18n="@@type.Firearm.personalFirearm">Personal Firearm</mat-label>
          <mat-select formControlName="personalFirearm" id="personalFirearmFilterInput"              
              (ngModelChange)="personalFirearmChanging($event)" [(ngModel)]="personalFirearmFilter"              
              (ngModelChange)="personalFirearmChanged($event)" #personalFirearmFilterInput>
            <mat-option>Any</mat-option>
            <mat-option [value]="true" i18n="@@type.boolean.true">Yes</mat-option>
            <mat-option [value]="false" i18n="@@type.boolean.false">No</mat-option>
          </mat-select>
        </mat-form-field>

         <mat-form-field matTooltip="Disposal Date From"
          [matTooltipDisabled]="disabledTooltip(this.disposalDateGreaterThanOrEqualTo)">
          <mat-label i18n="@@type.Firearm.disposalDateGreaterThanOrEqualTo">Disposal Date From</mat-label>
          <input matInput formControlName="disposalDateGreaterThanOrEqualTo"
            id="disposalDateGreaterThanOrEqualToFilterInput"
            (ngModelChange)="disposalDateGreaterThanOrEqualToChanging($event)"
            [(ngModel)]="disposalDateGreaterThanOrEqualToFilter"
            (ngModelChange)="disposalDateGreaterThanOrEqualToChanged($event)"
            #disposalDateGreaterThanOrEqualToFilterInput
            [matDatepicker]="disposalDateGreaterThanOrEqualToDatePicker" (dateChange)="maybeDoAutoSearch()"
            placeholder="Disposal Date From">
          <mat-datepicker-toggle matSuffix [for]="disposalDateGreaterThanOrEqualToDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #disposalDateGreaterThanOrEqualToDatePicker color="primary"></mat-datepicker>
        </mat-form-field>

        <mat-form-field matTooltip="Disposal Date To"
          [matTooltipDisabled]="disabledTooltip(this.disposalDateLessThanOrEqualTo)">
          <mat-label i18n="@@type.Firearm.disposalDateLessThanOrEqualTo">Disposal Date To</mat-label>
          <input matInput formControlName="disposalDateLessThanOrEqualTo" id="disposalDateLessThanOrEqualToFilterInput"
            (ngModelChange)="disposalDateLessThanOrEqualToChanging($event)"
            [(ngModel)]="disposalDateLessThanOrEqualToFilter"
            (ngModelChange)="disposalDateLessThanOrEqualToChanged($event)" #disposalDateLessThanOrEqualToFilterInput
            [matDatepicker]="disposalDateLessThanOrEqualToDatePicker" (dateChange)="maybeDoAutoSearch()"
            placeholder="Disposal Date To">
          <mat-datepicker-toggle matSuffix [for]="disposalDateLessThanOrEqualToDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #disposalDateLessThanOrEqualToDatePicker color="primary"></mat-datepicker>
        </mat-form-field>


      </div>

      <div class="search-section">
        <mat-form-field matTooltip="Select a Lifecycle State from the list" [matTooltipDisabled]="disabledTooltip(this.lifecycleState)">
          <mat-label i18n="@@type.Firearm.lifecycleState">Lifecycle State</mat-label>
          <mat-select formControlName="lifecycleStatuses" id="lifecycleStatusesFilterInput"              
              (ngModelChange)="lifecycleStatusesChanging($event)" [(ngModel)]="lifecycleStatusesFilter"              
              (ngModelChange)="lifecycleStatusesChanged($event)" #lifecycleStatusesFilterInput              
              placeholder="Lifecycle State" multiple>
            <mat-option *ngFor="let lifecycleState of lifecycleStateSelectionList" [value]="lifecycleState.code">
              {{lifecycleState.meaning}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field matTooltip="Select a Suspended from the list"
          [matTooltipDisabled]="disabledTooltip(this.suspended)">
          <mat-label i18n="@@type.Firearm.suspended">Suspended</mat-label>
          <mat-select formControlName="suspended" id="suspendedFilterInput" (ngModelChange)="suspendedChanging($event)"
            [(ngModel)]="suspendedFilter" (ngModelChange)="suspendedChanged($event)" #suspendedFilterInput>
            <mat-option>Any</mat-option>
            <mat-option [value]="true" i18n="@@type.boolean.true">Yes</mat-option>
            <mat-option [value]="false" i18n="@@type.boolean.false">No</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field matTooltip="Select a Currently Assignable from the list"
          [matTooltipDisabled]="disabledTooltip(this.currentlyAssignable)">
          <mat-label i18n="@@type.Firearm.currentlyAssignable">Currently Assignable</mat-label>
          <mat-select formControlName="currentlyAssignable" id="currentlyAssignableFilterInput"
            (ngModelChange)="currentlyAssignableChanging($event)" [(ngModel)]="currentlyAssignableFilter"
            (ngModelChange)="currentlyAssignableChanged($event)" #currentlyAssignableFilterInput>
            <mat-option>Any</mat-option>
            <mat-option [value]="true" i18n="@@type.boolean.true">Yes</mat-option>
            <mat-option [value]="false" i18n="@@type.boolean.false">No</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field matTooltip="Select a Currently Assigned from the list"
          [matTooltipDisabled]="disabledTooltip(this.currentlyAssigned)">
          <mat-label i18n="@@type.Firearm.currentlyAssigned">Currently Assigned</mat-label>
          <mat-select formControlName="currentlyAssigned" id="currentlyAssignedFilterInput"
            (ngModelChange)="currentlyAssignedChanging($event)" [(ngModel)]="currentlyAssignedFilter"
            (ngModelChange)="currentlyAssignedChanged($event)" #currentlyAssignedFilterInput>
            <mat-option>Any</mat-option>
            <mat-option [value]="true" i18n="@@type.boolean.true">Yes</mat-option>
            <mat-option [value]="false" i18n="@@type.boolean.false">No</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field matTooltip="Current Assignment Email"
          [matTooltipDisabled]="disabledTooltip(this.currentAssignmentEmail)">
          <mat-label i18n="@@type.Firearm.currentAssignmentEmail">Current Assignment Email</mat-label>
          <input matInput formControlName="currentAssignmentEmail" id="currentAssignmentEmailFilterInput"
            (ngModelChange)="currentAssignmentEmailChanging($event)" [(ngModel)]="currentAssignmentEmailFilter"
            (ngModelChange)="currentAssignmentEmailChanged($event)" #currentAssignmentEmailFilterInput
            placeholder="Current Assignment Email" disabled>
        </mat-form-field>

        <mat-form-field matTooltip="Select a Current Assignment Type from the list"
          [matTooltipDisabled]="disabledTooltip(this.currentAssignmentFirearmAssignmentType)">
          <mat-label i18n="@@type.Firearm.currentAssignmentFirearmAssignmentType">Current Assignment Firearm Assignment
            Type</mat-label>
          <mat-select formControlName="currentAssignmentFirearmAssignmentType"
            id="currentAssignmentFirearmAssignmentTypeFilterInput"
            (ngModelChange)="currentAssignmentFirearmAssignmentTypeChanging($event)"
            [(ngModel)]="currentAssignmentFirearmAssignmentTypeFilter"
            (ngModelChange)="currentAssignmentFirearmAssignmentTypeChanged($event)"
            #currentAssignmentFirearmAssignmentTypeFilterInput placeholder="Current Assignment Firearm Assignment Type">
            <mat-option>Any</mat-option>
            <mat-option
              *ngFor="let currentAssignmentFirearmAssignmentType of currentAssignmentFirearmAssignmentTypeSelectionList"
              [value]="currentAssignmentFirearmAssignmentType.code">
              {{currentAssignmentFirearmAssignmentType.meaning}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <ng-container matColumnDef="poolFirearm">
          <mat-header-cell [crud-column-header]="columns.column('poolFirearm')" *matHeaderCellDef
            cdkDropList cdkDropListLockAxis="x"
            cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
            class="search-column-small" i18n="@@type.Firearm.poolFirearm">
              Pool Firearm 
            </mat-header-cell>
          <mat-cell class="search-column-small" *matCellDef="let element">
            <mat-icon *ngIf="element.poolFirearm">check_box</mat-icon><mat-icon *ngIf="!element.poolFirearm">check_box_outline_blank</mat-icon>
          </mat-cell>
        </ng-container>  

      </div>

      <div class="search-section export-section">
        <mat-form-field class="field-quarter-width">
          <mat-label i18n="@@actions.reportRun.format">Format</mat-label>
          <mat-select [(ngModel)]="reportRun.outputFormat" formControlName="outputFormat" id="outputFormat"
            name="outputFormat" required>
            <mat-option *ngFor="let outputFormat of reportRun.outputFormats" [value]="outputFormat">
              {{outputFormat.name | refDecode:'REPORT_OUTPUT_FORMAT' | async }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <span>
          <mat-checkbox [(ngModel)]="reportRun.download" formControlName="download" id="download" name="download"
            class="field-quarter-width" labelPosition="after" disabled="{{reportRun.outputFormat?.downloadOnly}}"
            i18n="@@actions.reportRun.download">Download
          </mat-checkbox>
        </span>

        <button mat-raised-button color="primary" class="action-button" (click)="exportAction()" type="button"
          i18n="@@actions.reportRun" [disabled]="!isExportEnabled()">Export</button>

		    <mat-slide-toggle floatLabel="always" appearance="none" color="primary"  *ngIf="autoSearchControlsEnabled"
          [(ngModel)]="autoSearch"  [ngModelOptions]="{standalone: true}">
            Auto Search
        </mat-slide-toggle>

        <button mat-raised-button color="primary" class="action-button" (click)="forceSearch()" type="button"
          i18n="@@actions.search">Search</button>

        <button mat-raised-button color="primary" class="action-button" (click)="clearFilters()" type="button"
          [disabled]="!allowsClearFilters()" i18n="@@actions.clearFilters">Clear Filters</button>
      </div>

    </form>

    <div class="mat-elevation-z8">
      <div class="mat-table-wrapper">
        <mat-table #table [dataSource]="dataSource" matSort matSortDirection="asc" matSortDisableClear cdkDropList
          cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" Group>

          <app-firearm-search-result-columns [columns]="columns"></app-firearm-search-result-columns>

          <app-asset-search-result-columns [columns]="columns" [useCostCentreFullDisplay]="false" [useBusinessUnitFullDisplay]="false"
            [assetGetter]="assetGetter"></app-asset-search-result-columns>

          <ng-container matColumnDef="actions" stickyEnd>
            <mat-header-cell class="search-column-actions mat-elevation-z9" *matHeaderCellDef>
              <span i18n="@@common.actions">Actions</span>
              <app-column-picker-dialog-launcher [columns]="columns">
              </app-column-picker-dialog-launcher>
            </mat-header-cell>
            <mat-cell *matCellDef="let element" class="search-column-actions mat-elevation-z9">
              <button class="action-button" *ngIf="allowsPool(element)" mat-raised-button [color]="element.firearmPoolExisting ? 'primary' : 'accent2'"
                [routerLink]="poolRoute(element)" [queryParams]="poolRouteQueryParams()" i18n="@@actions.pool" [disabled]="!isPoolEnabled(element)"
                id="actions.pool">Pool</button>
              <button class="action-button" *ngIf="allowsEdit(element)" mat-raised-button color="primary"
                [routerLink]="editRoute(element)" [queryParams]="editRouteQueryParams()" i18n="@@actions.edit"
                id="actions.edit">Edit</button>
              <button class="action-button" [queryParams]="viewRouteQueryParams()" *ngIf="allowsView(element)"
                mat-raised-button color="primary" [routerLink]="viewRoute(element)" i18n="@@actions.view"
                id="actions.view">View</button>
              <button class="action-button" *ngIf="allowsDelete(element)" mat-raised-button color="warn"
                (click)="deleteWithConfirmation(element)" i18n="@@actions.delete" id="actions.delete">Delete</button>
            </mat-cell>
          </ng-container>
          <mat-header-row *matHeaderRowDef="columns.displayedColumns" class="search-table"></mat-header-row>
          <mat-row *matRowDef="let row; columns: columns.displayedColumns;" class="search-table"></mat-row>
        </mat-table>
      </div>
      <mat-paginator [length]="pageInfo.totalElements" [pageSize]="pageInfo.size" [pageSizeOptions]="pageSizes">
      </mat-paginator>
      <button class="action-button" *ngIf="allowsCreate()" mat-raised-button color="primary"
        [routerLink]="createRoute()" [queryParams]="createRouteQueryParams()" i18n="@@actions.acquire"
        id="actions.acquire">Acquire</button>
        
      <button class="action-button" *ngIf="allowsBack()" mat-raised-button color="accent" [routerLink]="backRoute()"
        [queryParams]="backRouteQueryParams()" i18n="@@actions.back" id="actions.back">Back</button>
    </div>
  </mat-card-content>
</mat-card>
